module.exports = __webpack_public_path__ + "static/media/sucess.4564e768.svg";